export default __webpack_public_path__ + "static/justin_osborne-e27b1e84b3e7fc5fea2cc9da1d5ad07b.png";